import Dropzone from "react-dropzone";
import styled from "styled-components";
import { useState } from "react";
import { Alert } from "@mui/material";

const WrapperAlert = styled.div`
  position: absolute;
  top: 0;
  left: 50%;
  transform: translate(-50%, 0);
  width: 100%;
  height: 50px;
  z-index: 3000;
  animation: showAlert 0.5s;
  margin-top: 16px;
  display: flex;
  justify-content: center;
  @keyframes showAlert {
    0% {
      opacity: 1;
    }
    100% {
      opacity: 1;
    }
  }
`;

const DivAlert = styled.div`
  min-width: 320px;
  width: fit-content;
  .MuiPaper-root-MuiAlert-root {
    border-radius: 16px;
  }
`;

const UploadMultiImage = ({
  children,
  callBackFile,
  limitFile = 0,
  sizeFile = 4194304,
  isDisabled = false,
}) => {
  const [alertInfo, setAlertInfo] = useState({
    visible: false,
    message: "",
  });

  const onDrop = async (acceptedFiles, fileRejections) => {
    let resultFiles = [];

    const fileUpload = acceptedFiles.map((file) =>
      Object.assign(file, {
        fileData: URL.createObjectURL(file),
      }),
    );

    if (acceptedFiles.length === 0) {
      if (
        fileRejections.length > 0 &&
        fileRejections[0]?.errors[0]?.code === "file-too-large"
      ) {
        setAlertInfo({
          visible: true,
          message: "File size is larger than 4 MB.",
        });
        setTimeout(() => {
          setAlertInfo({
            visible: false,
            message: "",
          });
        }, 2500);
      } else if (
        fileRejections.length > 0 &&
        fileRejections[0]?.errors[0]?.code === "too-many-files"
      ) {
        setAlertInfo({
          visible: true,
          message: `Number of files is more than ${limitFile}.`,
        });
        setTimeout(() => {
          setAlertInfo({
            visible: false,
            message: "",
          });
        }, 2500);
      }
    } else {
      await acceptedFiles.map(async (file, i) => {
        const reader = new FileReader();
        reader.onload = (e) => {
          resultFiles[i] = e.target.result;
          // callBackFile(fileUpload[0], e.target.result);
        };
        reader.readAsDataURL(file);
        return file;
      });

      await callBackFile(fileUpload);
    }
  };

  return (
    <>
      <Dropzone
        onDrop={(acceptedFiles, fileRejections) =>
          onDrop(acceptedFiles, fileRejections)
        }
        accept={[".jpeg", ".png", ".jpg"]}
        maxSize={sizeFile}
        maxFiles={limitFile}
        disabled={isDisabled}
        // minSize={0}
      >
        {({ getRootProps, getInputProps }) => (
          <section style={{ width: "100%" }}>
            <div {...getRootProps()}>
              <input {...getInputProps()} />
              <div>{children}</div>
            </div>
          </section>
        )}
      </Dropzone>
      {alertInfo.visible && (
        <WrapperAlert>
          <DivAlert>
            <Alert
              severity={"warning"}
              sx={{ "&.MuiPaper-root": { margin: 0 } }}
            >
              {alertInfo.message}
            </Alert>
          </DivAlert>
        </WrapperAlert>
      )}
    </>
  );
};

export default UploadMultiImage;
